import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../index.css";
import "./Signup.css";
import logo from "../assets/logo.png.png";

const getPasswordStrength = (p) => {
  if (!p) return 0;
  let score = 0;
  if (p.length >= 6)           score++;
  if (p.length >= 10)          score++;
  if (/[A-Z]/.test(p))         score++;
  if (/[0-9]/.test(p))         score++;
  if (/[^a-zA-Z0-9]/.test(p))  score++;
  return score;
};

const STRENGTH_LABEL = ["", "Faible", "Faible", "Moyen", "Bon", "Fort"];
const STRENGTH_COLOR = ["", "#e74c3c", "#e67e22", "#f0a500", "#27ae60", "#1e8449"];

function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading]   = useState(false);
  const [error,   setError]     = useState("");

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });
  const strength       = getPasswordStrength(form.password);
  const passwordsMatch  = form.confirmPassword && form.password === form.confirmPassword;
  const passwordsMismatch = form.confirmPassword && form.password !== form.confirmPassword;

  const handleSignup = async () => {
    setError("");
    if (!form.name || !form.email || !form.password || !form.confirmPassword) {
      setError("Veuillez remplir tous les champs"); return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Les mots de passe ne correspondent pas"); return;
    }
    if (form.password.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères"); return;
    }
    try {
      setLoading(true);
      const res = await fetch("http://das-cloud.com:5000/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name:     form.name,
          email:    form.email.trim().toLowerCase(),
          password: form.password,
        }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Erreur d'inscription"); return; }

      // ✅ Rediriger vers la page OTP avec l'email en paramètre
      navigate(`/verify-otp?email=${encodeURIComponent(form.email)}`);

    } catch {
      setError("Erreur serveur — vérifiez que le backend est démarré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <button
        style={{
          position: "fixed", top: "20px", left: "24px", zIndex: 99999,
          background: "rgba(255,255,255,0.9)", border: "1.5px solid #E2E8F0",
          borderRadius: 20, padding: "8px 16px", fontSize: "0.8rem", fontWeight: 700,
          color: "#6366f1", cursor: "pointer", fontFamily: "inherit",
          display: "flex", alignItems: "center", gap: 6,
        }}
        onClick={() => navigate("/")}
      >
        ← Accueil
      </button>
      <div className="login-card">
        <div className="login-left">
          <div className="company-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            <img src={logo} alt="LOGIMES Logo" />
          </div>
          <h1>Bienvenue sur LOGIMES ...</h1>
          <p>This platform allows secure integration, file processing and data exchange with TEIF services.</p>
          <span className="footer-text">© 2026 LOGIMES · v1.0.0</span>
        </div>

        <div className="login-right">
          <h2>Créer un compte</h2>
          <p className="subtitle">Créez votre compte pour accéder à votre espace de travail.</p>

          {/* Erreur globale */}
          {error && (
            <div style={{
              background: "#fff0f0", color: "#dc2626", borderRadius: 8,
              padding: "10px 14px", fontSize: "0.82rem", marginBottom: 16,
              border: "1px solid #fecaca"
            }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label>Nom complet</label>
            <input
              type="text"
              placeholder="Entrez votre nom complet"
              value={form.name}
              onChange={update("name")}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Entrez votre email"
              value={form.email}
              onChange={update("email")}
            />
          </div>

          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              placeholder="Min. 6 caractères"
              value={form.password}
              onChange={update("password")}
            />
            {form.password && (
              <div className="strength-bar-wrap">
                <div className="strength-bar">
                  {[1,2,3,4,5].map((i) => (
                    <div key={i} className="strength-segment"
                      style={{ background: i <= strength ? STRENGTH_COLOR[strength] : "#e0e0f0" }} />
                  ))}
                </div>
                <span style={{ color: STRENGTH_COLOR[strength], fontSize: "0.78rem", fontWeight: 600 }}>
                  {STRENGTH_LABEL[strength]}
                </span>
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Confirmer le mot de passe</label>
            <div style={{ position: "relative" }}>
              <input
                type="password"
                placeholder="Confirmez votre mot de passe"
                value={form.confirmPassword}
                onChange={update("confirmPassword")}
                style={{
                  borderColor: passwordsMatch ? "#27ae60" : passwordsMismatch ? "#e74c3c" : undefined,
                  paddingRight: "36px"
                }}
              />
              {passwordsMatch    && <span className="pwd-icon" style={{ color: "#27ae60" }}>✓</span>}
              {passwordsMismatch && <span className="pwd-icon" style={{ color: "#e74c3c" }}>✗</span>}
            </div>
            {passwordsMismatch && (
              <span style={{ color: "#e74c3c", fontSize: "0.78rem", marginTop: "4px" }}>
                Les mots de passe ne correspondent pas
              </span>
            )}
          </div>

          <button
            className="login-btn"
            onClick={handleSignup}
            disabled={loading}
          >
            {loading ? "Création en cours..." : "CRÉER MON COMPTE"}
          </button>

          <p className="signup">
            Déjà un compte ?{" "}
            <Link to="/login" style={{ color: "#4f8cff", textDecoration: "underline" }}>
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;